module.exports = __webpack_public_path__ + "img/appltCourse-img35.76479024.png";